import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function DeputyRegistrarColleges() {
  const navigate = useNavigate();  // still needed for the auth redirect

  const localUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      return null;
    }
  })();

  const moduleId = parseInt(localUser?.moduleId, 10);

  useEffect(() => {
    if (moduleId !== 26) {
      navigate("/");
    }
  }, [moduleId, navigate]);

  if (moduleId !== 26) return null;

  return (
    <div className="container mt-4">
      <h3 className="ctitle">Deputy Registrar Colleges</h3>
    </div>
  );
}
